<script lang='ts'>
  import { tick } from 'svelte';
  import * as _ from 'lodash';
  import { slide } from 'svelte/transition';
  import Icon from '@shared/svelte/Components/Icon.svelte';
  import type { Storefront, StorefrontProductCard, StorefrontCollection } from 'app/javascript/shared/javascripts/types/Storefront';
  import ProductCardOrganizer from './ProductCardOrganizer.svelte';
  import EnableSwitch from './EnableSwitch.svelte';

  const MAX_CARDS = 12
  export let storefront : Storefront;
  export let callbacks: any;
  export let collection : StorefrontCollection
  let slideDuration = 0;

  let storageName = 'storefrontCollectionSavedCollapsibleState-' + collection.id

  let collapseState = localStorage.getItem(storageName);
  function getInitialCollapsibleState() {
    if (collapseState) {
      return true
    } else if ((storefront.storefront_collections_attributes || []).length < 2 ||
      !collection || !collection.id ||
      !(collection.storefront_product_cards_attributes || []).length) {
      return true
    }
    return false;
  }

  let showProducts:boolean = getInitialCollapsibleState();
  async function toggleShowProducts() {
    slideDuration = 0 // still cannot get this to work quite right
    if (showProducts === true) {
      showProducts = false
      localStorage.removeItem(storageName)
    } else {
      showProducts = true
      localStorage.setItem(storageName, '1')
    }
    await tick();
    slideDuration = 0
  }

  function showProductChooser() {
    if (!collection.id) {
      return update();
    }
    callbacks.showProductChooser({
      storefront: storefront,
      onSelectProduct: onSelectProduct,
      productChooserOptions: {selectMultiple: true, selectMax: MAX_CARDS, selectMin: 0, maxRequired: true},
      selectMultipleChoices: selectedCards
    })
  }

  function update() {
    let scroller = document.getElementById('storefronts-left-pane-scroller')
    if (scroller) {
      localStorage.setItem('lastCollectionModified', `${scroller.scrollTop}`)
    }
    callbacks.update({
      id: storefront.id,
      storefront_collections_attributes: [collection]
    });
    let scrollEl = document.getElementById('collections');
    if (scrollEl) {
      scrollEl.scrollIntoView({block: "center", inline: "nearest", behavior: "smooth"});
    }
  }

  function onSelectProduct(plids:object) {
    let toSend : StorefrontProductCard[] = [];

    Object.keys(plids).map(function(x) { return parseInt(x)}).forEach(function(plid) {
      let currentlySelected = _.find(collection.storefront_product_cards_attributes, function(card: any) {
        return card.product_line_id == plid });

      if (currentlySelected && plids[plid] == false) {
        toSend.push({
          id: currentlySelected.id,
          _destroy: true
        });
      } else if (plids[plid] == true && !currentlySelected) {
        toSend.push({
          product_line_id: plid,
        });
      }
    });

    collection.storefront_product_cards_attributes = toSend;
    localStorage.setItem(storageName, '1')
    update();
  }

  function saveRemove(card: StorefrontProductCard) {
    card._destroy = true;
    update();
  }

  function saveSort(sortOrder : StorefrontProductCard[]) {
    collection.storefront_product_cards_attributes = sortOrder;
    update();
  }

  function deleteCollection() {
    collection._destroy = true;
    update();
  }

  function prepSelected() {
    return _.reduce(collection.storefront_product_cards_attributes, function(obj: any, entry: any) {
      obj[entry.product_line_id] = true;
      return obj;
    }, {});
  };

  function scrollToEditor() {
    let lastCollectionModified = localStorage.getItem('lastCollectionModified')
    if (lastCollectionModified !== null) {
      let scroller = document.getElementById('storefronts-left-pane-scroller')
      if (scroller) {
        scroller.scrollTop = parseInt(lastCollectionModified)
      }
    }
  }

  let selectedCards = [];

  $: {
    slideDuration = 0;
    storefront = storefront;
    selectedCards = prepSelected();
    scrollToEditor();
  }
</script>

<dd class='fizz-stack-24' data-key={collection.id} data-id={collection.id} id='collection-dd-{collection.id}'>
  <section class="fizz-text-small">
    <p class="fizz-label fizz-stack-16 fizz-space-between">
      <Icon
        width="16"
        height="16"
        type="GrabHandle" extraClassNames='cursor-grab collection-grab-handle'
      ></Icon>
      <span>Product Collection</span>
      <Icon
        width="16"
        height="16" onPress={deleteCollection}
        type="Trash" extraClassNames='cursor-pointer'
      ></Icon>
      <EnableSwitch bind:val={collection.enabled} changeCB={update} loading={storefront.loading}
        domId={'storefront_collection_' + collection.id}></EnableSwitch>
    </p>

    <p class="fizz-label fizz-stack-8 fizz-space-between">
      <span>Title</span>
    </p>
    <input type="text"
      class="fizz-input-text fizz-stack-16 fizz-full-width"
      id='storefront-product-card-title'
      bind:value={collection.title}
      on:change={update}
      placeholder="Product Cards Title"
      disabled={!collection.id}>
    {#if collection.enabled}
      {#if collection.id}
        <p class="fizz-label fizz-space-between fizz-stack-16 cursor-pointer" on:click={toggleShowProducts}>
          Products ({collection.storefront_product_cards_attributes.length}/{MAX_CARDS})
          {#if showProducts}
            <Icon width="16" height="16" type="ArrowUp" className='cursor-pointer vertical-align-middle display-inline-block margin-right--smallest'></Icon>
          {:else}
            <Icon width="16" height="16" type="ArrowDown" className='cursor-pointer vertical-align-middle display-inline-block margin-right--smallest'></Icon>
          {/if}
        </p>
        {#if showProducts}
          <div transition:slide={{delay: 0, duration: slideDuration, easing: (c) => c}}>
            <ProductCardOrganizer productCards={collection.storefront_product_cards_attributes.filter(function(x) { return x.product_line; })}
                  {saveRemove} {saveSort} bind:collection></ProductCardOrganizer>
            <button class="fizz-button-small fizz-margin-auto"
              on:click={showProductChooser}>
              Modify Products
            </button>
          </div>
        {/if}
      {:else}
        Loading...
      {/if}
    {/if}
  </section>
</dd>

